import { render, staticRenderFns } from "./detailCardGoal.vue?vue&type=template&id=6a55cd7e&scoped=true"
import script from "./detailCardGoal.vue?vue&type=script&lang=js"
export * from "./detailCardGoal.vue?vue&type=script&lang=js"
import style0 from "./detailCardGoal.vue?vue&type=style&index=0&id=6a55cd7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55cd7e",
  null
  
)

export default component.exports